import { onUnmounted } from 'vue';
import { throttle as _throttle } from 'lodash';
import events from "../../services/EventBus";
import palomaWebsocket, {} from "../../services/WebSocket";
/**
 * Subscribes the data table to its global event bus events (`<name>.refresh`,
 * `<name>.reload`, `<name>.nav-next`, `<name>.nav-prev`, `<name>.activate`,
 * `<name>.activate-if-none-active`) and, if configured, to a WebSocket
 * destination whose messages trigger `<name>.<onUpdate>`.
 *
 * Handlers are registered synchronously (a parent may emit right after
 * mounting) and removed on unmount with their exact references, so other
 * tables listening to the same name are unaffected.
 */
export function useDataTableEvents(name, handlers, wsSettings) {
    if (!name) {
        return;
    }
    const subscriptions = [
        [name + '.refresh', handlers.refresh],
        [name + '.reload', handlers.reload],
        [name + '.nav-next', handlers.navNext],
        [name + '.nav-prev', handlers.navPrev],
        [name + '.activate', handlers.activate],
        [name + '.activate-if-none-active', handlers.activateIfNoneActive],
    ];
    subscriptions.forEach(([type, handler]) => events.$on(type, handler));
    let wsSubscription = null;
    let wsNotify = null;
    if (wsSettings) {
        wsNotify = _throttle(() => events.$emit(name + '.' + wsSettings.onUpdate), 1000);
        wsSubscription = palomaWebsocket.subscribe(wsSettings.destination, wsNotify);
    }
    onUnmounted(() => {
        subscriptions.forEach(([type, handler]) => events.$off(type, handler));
        wsNotify?.cancel();
        wsSubscription?.unsubscribe();
    });
}
